import React from 'react'

// Modal
import ModalDetalleCaja from './ModalDetalleCaja/ModalDetalleCaja'

// router
import { withRouter } from 'react-router-dom'

// services
import { recoverCaja } from '../../Services/cajaService'

// Sweet alert
import Swal from 'sweetalert2'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'

const ItemCajaReporteEliminada = ({ item, setIsLoad }) => {
    const recoverCajaSubmit = (caja) => {
        Swal.fire({
            title: 'Estas seguro de recuperarlo?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, Recuperar!',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.value) {
                // consulta a la api para eliminar
                recoverCaja(caja.id)
                    .then((res) => {
                        Swal.fire(
                            'Recuperado!',
                            'La caja fue recuperada.',
                            'success'
                        )
                        setIsLoad(true)
                    })
                    .catch((error) => {
                        Swal.fire({
                            type: 'error',
                            title: 'Error',
                            text: 'Hubo un error vuelve a intentar!',
                        })
                        console.log(error.response)
                    })
            }
        })
    }

    return (
        <tr>
            <th scope="row">{item.id}</th>
            <td>{item.puntoVenta.nombre}</td>
            <td>
                {new Date(item.createdAt).toLocaleString('es-AR', {
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                    hour12: false,
                })}
            </td>
            <td>
                {item.fechaCierre
                    ? new Date(item.fechaCierre).toLocaleString('es-AR', {
                          year: 'numeric',
                          month: 'numeric',
                          day: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit',
                          second: '2-digit',
                          hour12: false,
                      })
                    : '-'}
            </td>
            <td>${parseFloat(item.montoInicial).toFixed(2)}</td>
            <td>
                $
                {item.montoFinal != null
                    ? `${parseFloat(item.montoFinal).toFixed(2)}`
                    : `${'0.0'}`}
            </td>
            <td>
                <p className="text-primary">{item.estado}</p>
            </td>
            <td>
                <ModalDetalleCaja caja={item} />
                <button
                    className="btn text-warning"
                    onClick={() => {
                        recoverCajaSubmit(item)
                    }}
                >
                    <FontAwesomeIcon icon={faTrash} /> Recuperar
                </button>
            </td>
        </tr>
    )
}

export default withRouter(ItemCajaReporteEliminada)
